/*
 * View for Snippets Controls
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "./template/snippetsControlsTemplate.html",
], function (Marionette, $, _, SnippetsControlsTemplate) {
  const SnippetsControlsView = {};

  SnippetsControlsView.snippetsControlsView = Marionette.ItemView.extend({
    template: SnippetsControlsTemplate,
    modelEvents: {
      "change:exceededLimit": "render",
    },
    clearError: function () {
      this.ui.controlsError.html("");
    },
    controlsError: function (errorMessage) {
      this.ui.controlsError
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#snippetFolderText": {
        enableSelector: "#snippetFolderText",
        modelAttribute: "name",
        placeholder: "snippet.controls.folderPlaceholder",
        textArea: false,
      },
    },
    triggers: {
      "click #deleteSnippets": "delete:snippets",
      "click #moveSnippets": "move:snippets",
      "click #addFolder": "add:folder",
      "click #moveFolder": "move:folder",
      "click #deleteFolder": "delete:folder",
      "click #addSnippet": "add:new:snippet",
    },
    ui: {
      controlsError: "#controlsError",
      snippetFolderText: "#snippetFolderText",
    },
  });

  return SnippetsControlsView;
});
